import * as z from "zod";
import { OC } from "../../utils";
import { AdminDiscountCode } from "./schema";

export const discountCodeContract = OC.router({
  get: OC.meta({ permissions: ["discountCode:get"] })
    .input(AdminDiscountCode.Get)
    .output(AdminDiscountCode.DiscountCode),
  getAll: OC.meta({ permissions: ["discountCode:get"] })
    .input(AdminDiscountCode.GetAll)
    .output(
      z.array(AdminDiscountCode.DiscountCode.extend({ number: z.number() })),
    ),
  count: OC.meta({ permissions: ["discountCode:get"] })
    .input(
      AdminDiscountCode.GetAll.omit({
        page: true,
        limit: true,
        sortBy: true,
        sortOrder: true,
      }),
    )
    .output(z.number()),
  create: OC.meta({
    alters: true,
    permissions: ["discountCode:create"],
    auditLog: { modelName: "DISCOUNT_CODE", action: "CREATE" },
    aragon: "discount_code_created",
  })
    .input(AdminDiscountCode.Create)
    .output(AdminDiscountCode.DiscountCode),
  update: OC.meta({
    alters: true,
    permissions: ["discountCode:update"],
    auditLog: { modelName: "DISCOUNT_CODE", action: "UPDATE" },
    aragon: "discount_code_updated",
  })
    .input(AdminDiscountCode.Update)
    .output(AdminDiscountCode.DiscountCode),
  delete: OC.meta({
    alters: true,
    permissions: ["discountCode:delete"],
    auditLog: { modelName: "DISCOUNT_CODE", action: "DELETE" },
    aragon: "discount_code_deleted",
  })
    .input(AdminDiscountCode.Get)
    .output(AdminDiscountCode.DiscountCode),
});
